/* LodyFair snel-toevoegen vanaf een productkaart.

   De variantgegevens staan al bij de kaart in een <script type="application/json">,
   dus het openen van de popup kost geen enkele netwerkaanvraag. Toevoegen gaat
   via de AJAX-winkelwagen; daarna opent de LodyFair-lade, die zelf opnieuw
   beoordeelt of de gratis sokken erbij horen. */
(function () {
  var popup = document.getElementById('LfQuickAdd');
  if (!popup) return;

  var elFoto = popup.querySelector('[data-lf-qa-foto]');
  var elTitel = popup.querySelector('[data-lf-qa-titel]');
  var elPrijs = popup.querySelector('[data-lf-qa-prijs]');
  var elGroepen = popup.querySelector('[data-lf-qa-groepen]');
  var elFout = popup.querySelector('[data-lf-qa-fout]');
  var elToevoegen = popup.querySelector('[data-lf-qa-toevoegen]');
  var venster = popup.querySelector('.lf-qa__venster');

  var T = {
    maattabel: popup.dataset.tekstMaattabel || 'Twijfel over je maat?',
    fout: popup.dataset.tekstFout || 'Er ging iets mis. Probeer het opnieuw.',
    uitverkocht: popup.dataset.tekstUitverkocht || 'Deze combinatie is uitverkocht.'
  };

  var data = null;      // gegevens van het geopende product
  var keuze = [];       // gekozen waarde per optiegroep
  var opener = null;    // knop waarvandaan geopend is, voor het terugzetten van de focus
  var bezig = false;

  function geld(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---------- varianten ---------- */

  /* Sommige producten hebben dezelfde kleur twee keer, alleen anders
     geschreven ("Zwart" en "zwart"). Dat zou twee identieke knoppen geven,
     dus vergelijken en groeperen we hoofdletterongevoelig. Waarden die écht
     verschillen — bijvoorbeeld "Zwart (BIJNA UITVERKOCHT)" — blijven apart,
     want die zegt iets anders dan "Zwart". */
  function sleutel(waarde) {
    return String(waarde == null ? '' : waarde).trim().toLowerCase();
  }

  /* Dezelfde vorm als het Liquid-filter `handle`, voor zover we hem nodig
     hebben: zo komt de knop op dezelfde color-swatch--<naam> regel uit als
     de bolletjes op de productkaarten en de productpagina. */
  function handle(waarde) {
    return sleutel(waarde)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* Unieke waarden van een optiegroep, met de eerste schrijfwijze als label. */
  function waardenVan(index) {
    var gezien = {};
    var uniek = [];
    data.opties[index].waarden.forEach(function (w) {
      var s = sleutel(w);
      if (gezien[s]) return;
      gezien[s] = true;
      uniek.push(w);
    });
    return uniek;
  }

  function zoekVariant() {
    if (!data) return null;
    for (var i = 0; i < data.varianten.length; i++) {
      var v = data.varianten[i];
      var gelijk = true;
      for (var j = 0; j < data.opties.length; j++) {
        if (sleutel(keuze[j]) !== sleutel(v.o[j])) { gelijk = false; break; }
      }
      if (gelijk) return v;
    }
    return null;
  }

  /* Een waarde is kiesbaar als er een leverbare variant bestaat die deze waarde
     heeft én past bij wat er in de ANDERE groepen al gekozen is. Zolang er nog
     niets gekozen is, strepen we dus alleen weg wat overal uitverkocht is. */
  function isBeschikbaar(groepIndex, waarde) {
    for (var i = 0; i < data.varianten.length; i++) {
      var v = data.varianten[i];
      if (!v.b) continue;
      if (sleutel(v.o[groepIndex]) !== sleutel(waarde)) continue;
      var past = true;
      for (var j = 0; j < data.opties.length; j++) {
        if (j === groepIndex) continue;
        if (keuze[j] && sleutel(keuze[j]) !== sleutel(v.o[j])) { past = false; break; }
      }
      if (past) return true;
    }
    return false;
  }

  /* De foto die bij één kleurwaarde hoort, of null. Hoofdletterongevoelig,
     omdat dezelfde kleur soms als "Zwart" en soms als "zwart" in de catalogus
     staat en de knoppen op die manier ook gegroepeerd worden. */
  function kleurfotoVan(waarde) {
    if (!data || !data.kleurfotos) return null;
    var gezocht = sleutel(waarde);
    var namen = Object.keys(data.kleurfotos);
    for (var n = 0; n < namen.length; n++) {
      if (sleutel(namen[n]) === gezocht) return data.kleurfotos[namen[n]];
    }
    return null;
  }

  /* Foto's horen bij de kleur, niet bij elke losse variant: zodra er een kleur
     gekozen is tonen we de foto van die kleur, anders de hoofdfoto. */
  function fotoVoorKeuze() {
    var i = data.kleurIndex;
    if (i >= 0 && keuze[i]) {
      var foto = kleurfotoVan(keuze[i]);
      if (foto) return foto;
    }
    return data.foto;
  }

  /* ---------- tekenen ---------- */

  function tekenGroepen() {
    elGroepen.innerHTML = '';
    if (data.opties.length === 1 && data.opties[0].naam === 'Title') return;

    data.opties.forEach(function (optie, index) {
      var groep = document.createElement('div');
      groep.className = 'lf-qa__groep';

      var naam = document.createElement('p');
      naam.className = 'lf-qa__groep-naam';
      naam.textContent = optie.naam;
      groep.appendChild(naam);

      var rij = document.createElement('div');
      rij.className = 'lf-qa__waarden';

      var isKleurgroep = index === data.kleurIndex;
      if (isKleurgroep) rij.classList.add('lf-qa__waarden--bollen');

      waardenVan(index).forEach(function (waarde) {
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'lf-qa__waarde';
        knop.setAttribute('data-lf-qa-groep', index);
        knop.setAttribute('data-lf-qa-waarde', waarde);

        /* Kleuren worden ronde bolletjes: met de variantfoto als die er is,
           anders het effen kleurvlak. Zelfde vorm en maat, zodat een rij met
           deels gecorrigeerde foto's niet scheef staat. */
        if (isKleurgroep) {
          knop.classList.add('lf-qa__waarde--bol');
          /* color-swatch--<handle> komt uit lodyfair-accents.css en zet de
             effen kleur; die is zichtbaar zolang er geen foto is. */
          knop.classList.add('color-swatch', 'color-swatch--' + handle(waarde));
          knop.title = waarde;

          var foto = kleurfotoVan(waarde);
          if (foto) {
            var img = document.createElement('img');
            img.className = 'lf-qa__bolfoto';
            img.src = foto;
            img.alt = '';
            img.setAttribute('aria-hidden', 'true');
            knop.appendChild(img);
          }

          var verborgen = document.createElement('span');
          verborgen.className = 'visually-hidden';
          verborgen.textContent = waarde;
          knop.appendChild(verborgen);
        } else {
          knop.textContent = waarde;
        }

        if (sleutel(keuze[index]) === sleutel(waarde)) knop.classList.add('is-gekozen');
        if (!isBeschikbaar(index, waarde)) knop.disabled = true;
        rij.appendChild(knop);
      });

      groep.appendChild(rij);

      // maatadvies staat op de productpagina; niet blind laten gokken
      if (data.maat && optie.naam.toLowerCase().indexOf('maat') !== -1) {
        var link = document.createElement('a');
        link.className = 'lf-qa__maatlink';
        link.href = data.url;
        link.textContent = T.maattabel;
        groep.appendChild(link);
      }

      elGroepen.appendChild(groep);
    });
  }

  function tekenPrijs() {
    var v = zoekVariant();
    var prijs = v ? v.p : null;
    var oud = v ? v.c : 0;

    if (prijs === null) {
      // nog niets gekozen: laagste prijs van de leverbare varianten
      var leverbaar = data.varianten.filter(function (x) { return x.b; });
      var bron = leverbaar.length ? leverbaar : data.varianten;
      prijs = Math.min.apply(null, bron.map(function (x) { return x.p; }));
      oud = 0;
    }

    elPrijs.innerHTML = '';
    var nu = document.createElement('span');
    nu.textContent = geld(prijs);
    elPrijs.appendChild(nu);
    if (oud && oud > prijs) {
      var was = document.createElement('span');
      was.className = 'lf-qa__prijs-oud';
      was.textContent = geld(oud);
      elPrijs.appendChild(was);

      var label = kortingLabel(oud, prijs);
      if (label) {
        var korting = document.createElement('span');
        korting.className = 'lf-qa__korting';
        korting.textContent = label;
        elPrijs.appendChild(korting);
      }
    }
  }

  /* Hetzelfde kortingslabel als het lint op de productkaarten, met dezelfde
     instellingen en dezelfde afronding naar beneden. Zie
     snippets/lodyfair-korting-badge.liquid — verander ze samen, anders ziet de
     klant in de popup een ander percentage dan op de kaart waar hij klikte. */
  function kortingLabel(oud, nu) {
    if (popup.dataset.badgeUit) return '';
    var pct = Math.floor(((oud - nu) * 100) / oud);
    var drempel = parseInt(popup.dataset.badgeMin, 10);
    if (isNaN(drempel)) drempel = 10;
    if (pct < drempel) return '';

    var soort = popup.dataset.badgeType || 'procent';
    if (soort === 'vast') return popup.dataset.badgeVast || 'Sale';
    if (soort === 'bedrag') {
      var sjabloon = popup.dataset.tekstBespaar || 'Bespaar __BEDRAG__';
      return sjabloon.replace('__BEDRAG__', geld(oud - nu));
    }
    return '-' + pct + '%';
  }

  function tekenKnop() {
    var alles = data.opties.every(function (o, i) {
      return o.naam === 'Title' || keuze[i];
    });
    var variant = zoekVariant();
    var kanToevoegen = alles && variant && variant.b && !bezig;
    elToevoegen.disabled = !kanToevoegen;

    if (alles && variant && !variant.b) {
      toonFout(T.uitverkocht);
    } else {
      verbergFout();
    }
  }

  function teken() {
    elTitel.textContent = data.titel;
    /* Alleen een src zetten als er echt een foto is: een lege src betekent
       voor de browser "de huidige pagina" en dan wordt de hele pagina nog een
       keer gedownload als afbeelding. Geen foto = het element verborgen
       houden (het begint verborgen in de opmaak). */
    var foto = fotoVoorKeuze();
    if (foto) {
      elFoto.src = foto;
      elFoto.hidden = false;
    } else {
      elFoto.removeAttribute('src');
      elFoto.hidden = true;
    }
    elFoto.alt = data.titel;
    tekenGroepen();
    tekenPrijs();
    tekenKnop();
  }

  function toonFout(tekst) {
    elFout.textContent = tekst;
    elFout.hidden = false;
  }

  function verbergFout() {
    elFout.hidden = true;
  }

  /* ---------- openen en sluiten ---------- */

  function open(productId, knop) {
    var bron = document.querySelector('[data-lf-qa-data="' + productId + '"]');
    if (!bron) return;

    try {
      data = JSON.parse(bron.textContent);
    } catch (e) {
      return;
    }

    keuze = data.opties.map(function (o) {
      // één variant of een naamloze optie: niets te kiezen
      return (data.varianten.length === 1 || o.naam === 'Title') ? o.waarden[0] : null;
    });

    opener = knop || null;
    bezig = false;
    elToevoegen.classList.remove('is-bezig');
    verbergFout();
    teken();

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    var eerste = venster.querySelector('.lf-qa__waarde:not(:disabled)') || elToevoegen;
    if (eerste) eerste.focus();
  }

  function sluit() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  /* ---------- toevoegen ---------- */

  function voegToe() {
    var variant = zoekVariant();
    if (!variant || bezig) return;

    bezig = true;
    elToevoegen.classList.add('is-bezig');
    elToevoegen.disabled = true;
    verbergFout();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('toevoegen mislukt');
        return r.json();
      })
      .then(function () {
        bezig = false;
        elToevoegen.classList.remove('is-bezig');
        sluit();
        // de lade beoordeelt zelf opnieuw of de gratis sokken erbij horen
        if (window.lfCart && window.lfCart.open) {
          window.lfCart.open();
        } else {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }
      })
      .catch(function () {
        bezig = false;
        elToevoegen.classList.remove('is-bezig');
        elToevoegen.disabled = false;
        toonFout(T.fout);
      });
  }

  /* ---------- gebeurtenissen ---------- */

  function openVanaf(el, e) {
    e.preventDefault();
    e.stopPropagation();
    open(el.getAttribute('data-lf-qa-open'), el);
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-lf-qa-open]');
    if (knop) openVanaf(knop, e);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var knop = e.target.closest && e.target.closest('[data-lf-qa-open]');
    if (knop) openVanaf(knop, e);
  }, true);

  /* De "naar product"-variant van de knop (meer dan 14 keuzeknoppen: geen
     popup maar door naar de productpagina). Dit is een <span> en geen <a>,
     omdat de knop binnen de kaartlink staat en een link-in-een-link de kaart
     in de browser uiteen laat vallen — zie de toelichting in
     snippets/lodyfair-quick-add-knop.liquid. stopPropagation zodat de
     kaartlink eronder de klik niet ook nog afhandelt. */
  function naarProduct(el, e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = el.getAttribute('data-lf-qa-naar');
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-lf-qa-naar]');
    if (knop) naarProduct(knop, e);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var knop = e.target.closest && e.target.closest('[data-lf-qa-naar]');
    if (knop) naarProduct(knop, e);
  }, true);

  popup.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-qa-sluit]')) { sluit(); return; }

    var waarde = e.target.closest('[data-lf-qa-waarde]');
    if (waarde && !waarde.disabled) {
      var groep = parseInt(waarde.getAttribute('data-lf-qa-groep'), 10);
      var gekozen = waarde.getAttribute('data-lf-qa-waarde');
      keuze[groep] = (sleutel(keuze[groep]) === sleutel(gekozen)) ? null : gekozen;

      // een keuze elders kan de huidige selectie onmogelijk maken
      for (var j = 0; j < keuze.length; j++) {
        if (j !== groep && keuze[j] && !isBeschikbaar(j, keuze[j])) keuze[j] = null;
      }
      teken();
      return;
    }

    if (e.target.closest('[data-lf-qa-toevoegen]')) voegToe();
  });

  document.addEventListener('keydown', function (e) {
    if (!popup.classList.contains('is-open')) return;

    if (e.key === 'Escape') { sluit(); return; }

    // focus binnen de popup houden
    if (e.key === 'Tab') {
      var focusbaar = venster.querySelectorAll('button:not(:disabled), a[href], input, [tabindex]:not([tabindex="-1"])');
      if (!focusbaar.length) return;
      var eerste = focusbaar[0];
      var laatste = focusbaar[focusbaar.length - 1];
      if (e.shiftKey && document.activeElement === eerste) {
        e.preventDefault();
        laatste.focus();
      } else if (!e.shiftKey && document.activeElement === laatste) {
        e.preventDefault();
        eerste.focus();
      }
    }
  });

  window.lfQuickAdd = { open: open, sluit: sluit, _data: function () { return data; }, _keuze: function () { return keuze; } };
})();
